import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SigninPopupPage } from './signin-popup.page';

const routes: Routes = [
  {
    path: '',
    component: SigninPopupPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SigninPopupPageRoutingModule {}
